export default "__VITE_ASSET__Da_skt2H__"